module.exports = __webpack_public_path__ + "img/hod.c34800cc.png";